import { ErrorMessage, Field } from "formik";
import React, { useEffect, useMemo } from "react";
import TextError from "./TextError";
import { valudatesetformstatus } from "../../pages/onboarding/Onboarding";

const CheckBoxGroup = (props: any) => {
    const { name, label, option, className, allData, completedPage, candidateData, initialCandidateName, formik, ...rest } = props;

    const copyConfig = allData?.copyConfig || null;
    const mappings = useMemo(() => (Array.isArray(copyConfig?.mappings) ? copyConfig.mappings : []), [copyConfig]);

    const getCheckedValues = (rawValue: any): string[] => {
        if (Array.isArray(rawValue)) {
            return rawValue;
        }
        return rawValue ? [rawValue] : [];
    };

    const isCopyChecked = (rawValue: any) => {
        const checkedValues = getCheckedValues(rawValue);
        const checkedValue = copyConfig?.checkedValue ?? option?.[0]?.value ?? "yes";
        return checkedValues.includes(checkedValue);
    };

    const applyCopyValues = (form: any, shouldClear = false) => {
        if (!copyConfig || mappings.length === 0 || !form?.setFieldValue || !form?.values) {
            return;
        }

        mappings.forEach((pair: any) => {
            const fromName = pair?.from;
            const toName = pair?.to;
            if (!fromName || !toName) {
                return;
            }

            const sourceValue = form.values[fromName];
            const currentTargetValue = form.values[toName];
            const nextTargetValue = shouldClear
                ? (Array.isArray(currentTargetValue) ? [] : "")
                : sourceValue;

            if (JSON.stringify(currentTargetValue) !== JSON.stringify(nextTargetValue)) {
                form.setFieldValue(toName, nextTargetValue, false);
            }

            if (form.setFieldTouched) {
                form.setFieldTouched(toName, false, false);
            }
            if (form.setFieldError) {
                form.setFieldError(toName, undefined);
            }
        });
    };

    const sourceSignature = useMemo(() => {
        if (!formik?.values || mappings.length === 0) {
            return "";
        }
        return JSON.stringify(mappings.map((pair: any) => formik.values?.[pair?.from]));
    }, [formik?.values, mappings]);

    useEffect(() => {
        if (!copyConfig || copyConfig?.mode !== "mirror" || !formik?.values) {
            return;
        }
        if (isCopyChecked(formik.values[name])) {
            applyCopyValues(formik, false);
        }
    }, [copyConfig, formik, name, sourceSignature]);

    const fieldValidation = (value: any) => {
        let error;
        if (allData.validate) {
            if (allData.type === "checkbox-group" || allData.type === "checkbox") {
                allData?.validations.forEach((element: any) => {
                    if (allData.type === "checkbox-group" || allData.type === "checkbox") {
                        if ((!value || value?.length === 0) && valudatesetformstatus !== "draft" ) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        } else if (!value && valudatesetformstatus === "draft" && completedPage) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        }
                    }
                });
            }
        }
        return error;
    };
    return (
        <>
            <Field name={name} validate={fieldValidation} onBlur={(e: any) => e.preventDefault()} {...rest}>
                {
                    ({ field, form }: any) => {
                        return option.map((ress: any) => {
                            let newAgreeLabel : string = "";
                            if(ress.value === "Agree"){
                                let updatedCandidateName : string = "";
                                
                                const personalDetails = candidateData?.data.find((form: any) => form?.label === "Personal Details");
                                if (personalDetails) {
                                    const firstName = personalDetails.fields.find((fieldRow: any) => fieldRow?.label === "First Name")?.value || "";
                                    const lastName = personalDetails.fields.find((fieldRow: any) => fieldRow?.label === "Last Name")?.value || "";
                                    updatedCandidateName = `${firstName} ${lastName}`.trim();
                                }
                                if(ress.label.includes(initialCandidateName)){
                                    if (ress.label && updatedCandidateName !== "") {
                                        newAgreeLabel = ress.label.replace(initialCandidateName, updatedCandidateName);
                                        localStorage.setItem("newCandidateName", updatedCandidateName);
                                    }
                                }

                            }
                            return (
                                <div key={ress.value} className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={allData.name}
                                        {...field}
                                        value={ress.value}
                                        checked={field?.value?.includes(ress.value)}
                                        onChange={(event: any) => {
                                            const checked = event?.target?.checked;
                                            const nextValues = checked
                                                ? [...getCheckedValues(field?.value), ress.value]
                                                : getCheckedValues(field?.value).filter((item) => item !== ress.value);

                                            form.setFieldValue(name, nextValues);

                                            if (!copyConfig) {
                                                return;
                                            }

                                            const checkedValue = copyConfig?.checkedValue ?? option?.[0]?.value ?? "yes";
                                            const isActive = nextValues.includes(checkedValue);
                                            if (isActive) {
                                                applyCopyValues(form, false);
                                            } else if (copyConfig?.clearOnUncheck) {
                                                applyCopyValues(form, true);
                                            }
                                        }}
                                    />
                                    <label className={`form-check-label  ${ress?.fontWeightClass ? ress?.fontWeightClass : "fw-700"}`} htmlFor={allData.name}><span></span>{newAgreeLabel ? newAgreeLabel : ress.label} {allData.required && allData.type === "checkbox" ? <span className="star">*</span> : ""}</label>
                                </div>
                            );

                        });
                    }
                }
            </Field>
            <ErrorMessage name={name} component={TextError} />

        </>
    );
};

export default CheckBoxGroup;
